import React, { ChangeEvent, useCallback, useContext, useState } from 'react';

import { Box, Button, CircularProgress, Typography } from '@mui/material';

import { useMutation } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { FlexCol, FlexRow } from '../../../common/components/v2';
import { SnackBarType } from '../../layout/interfaces/ISnacksProps';
import { SnackbarContext } from '../../layout/SnackbarContext';
import { bulkInitiateQA } from './api';

const QAWorkflowPanel = () => {
  const { openSnack } = useContext(SnackbarContext);

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: bulkInitiateQA,
    onSuccess: ({ error }) => {
      if (error) {
        openSnack({
          id: uuidv4(),
          type: SnackBarType.ALERT,
          message: error.toString(),
        });
      } else {
        openSnack({
          id: uuidv4(),
          type: SnackBarType.SUCCESS,
          message: 'QA cases created successfully',
        });
      }
    },
  });

  const [file, setFile] = useState<File | null>(null);

  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const uploadedFile = event.target.files?.[0];
    setFile(uploadedFile ?? null);
  };

  const onSubmit = useCallback(() => {
    if (!file) return;
    return mutateAsync(file);
  }, [file, mutateAsync]);

  return (
    <Box>
      <Typography variant="h1" gutterBottom sx={{ mb: 1 }}>
        Initiate QA Workflow
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Upload CSV QA Workflow Cases
      </Typography>

      <FlexRow>
        <FlexCol>
          <Button
            variant="contained"
            component="label"
            disabled={isLoading}
            sx={{ mb: 2 }}
          >
            Upload CSV File
            <input
              type="file"
              accept=".csv"
              hidden
              onChange={handleFileUpload}
            />
          </Button>
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol>
          <Button
            variant="contained"
            color="success"
            disabled={!file || isLoading}
            onClick={onSubmit}
          >
            {isLoading ? <CircularProgress size={20} /> : 'Initiate Bulk QA'}
          </Button>
        </FlexCol>
      </FlexRow>
    </Box>
  );
};

export default QAWorkflowPanel;
